import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-delete-instruction',
  templateUrl: './delete-instruction.component.html',
  styleUrls: ['./delete-instruction.component.scss']
})
export class DeleteInstructionComponent implements OnInit {
  deleteUser: boolean = false;
  currentProtocol = window.location.protocol;
  currentDomain = window.location.hostname;
  domainUrl = `${this.currentProtocol}//${this.currentDomain}`;

  constructor(private router : Router) { }

  ngOnInit() {
  }


}
